export default __webpack_public_path__ + "static/media/person.5b58be10.svg";